import { WEBAPP_ROUTE_PREFIX } from '../../../constants/route'
import { useInitData, useLinkLikeClick } from '../../../hooks'
import { getFlatProfilePathname } from '../../../utils/link'
import { ProfileEntityWidgetItemContent } from '../ProfileEntityWidgetItemContent'

function ProfileFlatsWidgetItemContent({ value, ...restProps }) {
  const { handleClick, handleMouseDown } = useLinkLikeClick()

  const { availableSections } = useInitData()

  const link = getFlatProfilePathname({ availableSections, id: value })

  function handleClickTitle(event) {
    handleClick({
      event,
      link,
      outsideLink: link.includes(WEBAPP_ROUTE_PREFIX),
    })
  }

  function handleMouseDownTitle(event) {
    handleMouseDown({ event, link })
  }

  return (
    <ProfileEntityWidgetItemContent
      {...restProps}
      onClickTitle={handleClickTitle}
      onMouseDownTitle={handleMouseDownTitle}
    />
  )
}

export default ProfileFlatsWidgetItemContent
